<template>
  <img
    src="/ele-file-list/ic_file_excel.png"
    style="width: 1em; height: 1em; object-fit: contain"
  />
</template>
